(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global['has-a-digit'] = factory());
}(this, (function () { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  // eslint-disable-next-line no-self-compare
  var isFiniteNumber = function isFiniteNumber(value) {
    return typeof value === 'number' && Math.abs(value) !== Infinity && value === value || !!value && _typeof(value) === 'object' && Object.prototype.string.call(value) === '[object Number]';
  };

  var isString = function isString(value) {
    return typeof value === 'string' || !!value && _typeof(value) === 'object' && Object.prototype.string.call(value) === '[object String]';
  };

  var hasADigit = function hasADigit(value) {
    if (isFiniteNumber(value)) {
      return true;
    }

    if (isString(value)) {
      return /\d/.test(value);
    }

    return false;
  };

  return hasADigit;

})));
